import { render, staticRenderFns } from "./SupplyPoints.vue?vue&type=template&id=132f69ca"
import script from "./SupplyPoints.vue?vue&type=script&lang=js"
export * from "./SupplyPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports